import script from "./statutory-report.vue?vue&type=script&setup=true&lang=js"
export * from "./statutory-report.vue?vue&type=script&setup=true&lang=js"

import "./statutory-report.vue?vue&type=style&index=0&id=1038ac7d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1038ac7d"]])

export default __exports__